import {experimentTracking} from "./helpers"
import {LamedAdapter} from "alephbet"
import storage from "storage"

class StorageAdapter {
  constructor() {
    this.namespace = "alephbet"
    this.storage = storage.get(this.namespace) || {}
  }

  set(key, value) {
    this.storage[key] = value
    storage.set(this.namespace, this.storage)
    return value
  }

  get(key) {
    return this.storage[key]
  }
}

/* eslint-disable camelcase */
class LamedTrackingAdapter {
  experiment_start(experiment, variant) {
    experimentTracking(experiment.name, variant)
    lamedAdapter.experiment_start(experiment, variant)
  }

  goal_complete(experiment, variant, goalName, props) {
    lamedAdapter.goal_complete(experiment, variant, goalName, props)
  }
}
/* eslint-enable camelcase */

export const storageAdapter = new StorageAdapter()
export const superPropertiesLamedAdapter = new LamedTrackingAdapter()

export const lamedAdapter = new LamedAdapter(
  window.gon.lamedTrackUrl,
  window.gon.lamedNamespace,
  storageAdapter
)
